// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#intro {
    height: calc(100vh - 4rem);
    width: 100vw;
    max-width: 75rem;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
}

.bg {
    position: absolute;
    top: -4rem;
    right: 0;
    z-index: -1;
    object-fit: cover;
    height: 100vh;
}

.introContent {
    height: 100vh;
    width: 100vw;
    padding: 2rem;
    font-size: 3rem;
    font-weight: 700;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.hello {
    font-size: 1.75rem;
    font-weight: 100;
}

.introName {
    color:  #A1886F;
}

.introPara {
    font-size: medium;
    font-weight: 300;
    letter-spacing: 1px;
}

.construction {
    color: grey;
}

.btn {
    background: white;
    margin: 1rem 0;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 2rem;
}

.btnImg {
    object-fit: cover;
    margin: 0 0.25rem;
    height: 1rem;
}

@media screen and (max-width:840px) {
    .bg {
        right: -10vw
    }
    .introContent {
        font-size: 10vw;
    }
    .hello {
        font-size: 4.5vw;
    }
    
}

@media screen and (max-width:480px) {
    .bg {
        right: -20vw
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Intro/intro.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI;QACI;IACJ;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;;AAEJ;;AAEA;IACI;QACI;IACJ;AACJ","sourcesContent":["#intro {\n    height: calc(100vh - 4rem);\n    width: 100vw;\n    max-width: 75rem;\n    margin: 0 auto;\n    overflow: hidden;\n    position: relative;\n}\n\n.bg {\n    position: absolute;\n    top: -4rem;\n    right: 0;\n    z-index: -1;\n    object-fit: cover;\n    height: 100vh;\n}\n\n.introContent {\n    height: 100vh;\n    width: 100vw;\n    padding: 2rem;\n    font-size: 3rem;\n    font-weight: 700;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.hello {\n    font-size: 1.75rem;\n    font-weight: 100;\n}\n\n.introName {\n    color:  #A1886F;\n}\n\n.introPara {\n    font-size: medium;\n    font-weight: 300;\n    letter-spacing: 1px;\n}\n\n.construction {\n    color: grey;\n}\n\n.btn {\n    background: white;\n    margin: 1rem 0;\n    padding: 0.75rem 1.5rem;\n    border: none;\n    border-radius: 2rem;\n}\n\n.btnImg {\n    object-fit: cover;\n    margin: 0 0.25rem;\n    height: 1rem;\n}\n\n@media screen and (max-width:840px) {\n    .bg {\n        right: -10vw\n    }\n    .introContent {\n        font-size: 10vw;\n    }\n    .hello {\n        font-size: 4.5vw;\n    }\n    \n}\n\n@media screen and (max-width:480px) {\n    .bg {\n        right: -20vw\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
